import '../Style/RileyWorks.css';
import magic from '../Images/magic.png';
import book from '../Images/book.png';
import security from '../Images/security.png';

function RileyWorks() {
    return (
        <>
             <div className="container-fluid RileyWorks row  pt-5 pb-5 d-flex justify-content-center align-items-center m-0 ">
                <div className="content-RileyWorks text-center mb-4">
                    <h1 className="display-2 fw-bold">How Riley Works</h1>
                    <p className="fw-bold">Hint: it's not magic! Riley safely stores your data and uses the latest technology to help you make confident parenting decisions.</p>
                </div>             
                <div className='col-lg-2  btn-cu shadow text-center fw-bold p-3'> Get Started Now </div>

                <div className=' row mt-4 content-sliders gap-4 d-flex justify-content-center fw-bold '>

                    <div className='col-lg-3  p-3'>
                        <img src={security} alt='e' style={{width:"30%" , height:"auto"}} className='m-2' />
                        <h5 className='fw-bold'>Sharing advice, never your data</h5>
                        <p>Your family's safety matters. Any information you provide us is secure and never shared with anyone, ever.</p>
                </div>
                    <div className='col-lg-3  p-3'>
                        <img src={book} alt='e' style={{width:"30%" , height:"auto"}} className='m-2'/>
                        <h5 className='fw-bold'>Science-powered, AI-supported</h5>
                        <p>Skip the 3am panic Googling. Riley uses the best medical data and pediatrician-endorsed resources to provide reliable insights in seconds.</p>

                </div>
                    <div className='col-lg-3  p-3'>
                        <img src={magic} alt='e' style={{width:"30%" , height:"auto"}} className='m-2'/>
                        <h5 className='fw-bold'>Riley grows with your family</h5>
                        <p>There's no generic advice here! Riley personalizes itself to you based on the details you provide. The more details, the deeper the personalization.</p>
                </div>
                </div>

                </div>

        </>
    )
}
export default RileyWorks;